var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_556_6686)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2454 4.75C13.9792 4.75 15.5319 5.36 16.7564 6.55L20.1115 3.125C18.0739 1.19 15.4143 0 12.2454 0C7.65108 0 3.67883 2.69 1.74414 6.61L5.65271 9.705C6.57843 6.86 9.17924 4.75 12.2454 4.75Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5006 12.275C23.5006 11.49 23.4272 10.73 23.3145 10H12.2451V14.51H18.5831C18.299 15.99 17.4761 17.25 16.2419 18.1L20.028 21.1C22.237 19.01 23.5006 15.92 23.5006 12.275V12.275Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.64779 14.295C5.41268 13.57 5.27554 12.8 5.27554 12C5.27554 11.2 5.40779 10.43 5.64779 9.70499L1.73921 6.60999C0.940847 8.22999 0.490234 10.06 0.490234 12C0.490234 13.94 0.940847 15.77 1.74411 17.39L5.64779 14.295Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2454 24C15.4193 24 18.0886 22.935 20.0282 21.095L16.2421 18.095C15.1891 18.82 13.8323 19.245 12.2454 19.245C9.17926 19.245 6.57844 17.135 5.64783 14.29L1.73926 17.385C3.67885 21.31 7.6511 24 12.2454 24Z",
    fill: "#34A853"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_556_6686"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.065f04de0c44098ae7acd45b582fcdd9.svg";
export { ForwardRef as ReactComponent };